var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.isMobile)?_c('div',[_c('router-view')],1):_c('div',{staticClass:"no-use"},[_vm._v("\n    לא ניתן לשחק במשחק ממכשיר זה, יש להיכנס ממחשב עם מצלמה\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }